module.exports = __webpack_public_path__ + "media/season_fall.c5fe66ec.mp3";